export default "__VITE_ASSET__CCLB_Tom__"